module.exports = "<input placeholder=\"email\" [(ngModel)]=\"service.email\" (keyup.enter)=\"add()\" (paste)=\"add()\" type=\"email\">\r\n<a (click)=\"add()\" class=\"add-email mt15\" placeholder=\"Email Addresses\">+</a>\r\n<span *ngIf=\"service.emailError\" class=\"error\">{{ service.emailError }}</span>\r\n<div>\r\n  <ul>\r\n    <li *ngFor=\"let item of service.items; let index = index\">\r\n      <p>{{ item }} <a class='delete-email' (click)=\"remove(index)\">&times;</a></p>\r\n    </li>\r\n  </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/email-box/email-box.component.html
// module id = 687
// module chunks = 0